/** @jsx jsx */
import styled from '@emotion/styled'
import { jsx, Flex, Box, Heading } from 'theme-ui'
import ContentfulRichText from '../shared/Contentful/RichText'
import { BLOCKS } from '@contentful/rich-text-types'
import Body from '../shared/Typography/Body/Body'
import Button from '../shared/Buttons/Button'

const Wrapper = styled(Flex)`
  position: relative;

  margin: auto;
  height: auto;
  @media (min-width: ${props => props.theme.responsive.small}) {
    height: ${props => props.height || 'auto'};
  }
`

function getFlexFromContentAlign(align) {
  if (align === 'center') {
    return align
  }
  if (align === 'left') {
    return 'flex-start'
  }
  return 'flex-end'
}

const TextSection = props => {
  const options = {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Body
        sx={{ color: props.theme && props.theme.textColor }}
        variant="textSection"
      >
        {children}
      </Body>
    ),
    [BLOCKS.QUOTE]: (node, children) => (
      <Body as="blockquote" sx={{ fontStyle: 'italic' }}>
        {children}
      </Body>
    ),
  }

  return (
    <Wrapper
      sx={{
        width: ['100%'],
        textAlign: props.contentAlign,
        justifyContent: getFlexFromContentAlign(props.contentAlign),
        alignItems: getFlexFromContentAlign(props.contentAlign),
        marginTop: '40px',
        bg: props.theme && props.theme.backgroundColor,
      }}
    >
      <Box>
        <ContentfulRichText text={props.text} customOptions={options} />
        {props.actionButton && (
          <Button
            variant={props.actionButton.buttonStyle}
            size={props.actionButton.buttonSize}
            to={props.toSlug}
            styles={{ minWidth: '200px' }}
          >
            {props.actionButton.buttonLabel}
          </Button>
        )}
      </Box>
    </Wrapper>
  )
}

export default TextSection
